<template>
  <div class="container">
    <div class="box">
      <div class="columns is-multiline" v-if="location">
        <div class="column is-8">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="field">
                <label class="label">Name</label>
                <div class="control">
                  <input type="text" class="input" placeholder="Title" v-model="location.name">
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <label class="label">Tagline</label>
                <div class="control">
                  <input type="text" class="input" placeholder="Title" v-model="location.tagline">
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <label class="label">About</label>
                <div class="control">
                  <!-- rich text vue-quill-editor plugin -->
                  <quill-editor v-model="location.about" :options="editorOptions">
                  </quill-editor>
                  <input type="file" id="getImage" style="display: none;" @change="uploadImage">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="field">
                <div class="control">
                  <label class="label">Featured Image</label>
                  <figure class="image is-5by4" v-if="location.featuredImage">
                    <img :src="location.featuredImage">
                  </figure>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <div class="file">
                    <label class="file-label">
                      <input @change="uploadImages" class="file-input" type="file" name="resume"
                             accept=".jpg, .jpeg, .png"/>
                      <span class="file-cta">
                      <span class="file-icon">
                        <i class="fa fa-upload"></i>
                      </span>
                      <span class="file-label">
                        Choose a Featured Image…
                      </span>
                    </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="field">
                <p class="heading">Location Gallery</p>
                <div class="control has-icons-left">
                  <div class="select">
                    <select v-model="location.gallery">
                      <option value="null">Select Gallery</option>
                      <option v-for="gallery in galleries" :key="gallery['.key']" :value="gallery['.key']">{{gallery.title}}</option>
                    </select>
                  </div>
                  <div class="icon is-small is-left">
                    <i class="fa fa-picture-o"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- the form buttons -->
      <button type="submit" class="button is-success" @click="updateLocation('published')">Publish</button>
      <button type="submit" class="button is-info" @click="updateLocation('saved')">Save Draft</button>
      <router-link to="/admin/locations" class="button is-danger">Cancel</router-link>

      <!-- notification -->
      <transition mode="out-in" name="fade">
        <div v-if="notification.message" :class="'notification is-' + notification.type">
          <button class="delete" @click="hideNotifications"></button>
          {{notification.message}}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import {mediaRef, locationsRef, galleriesRef} from '@/firebase_config'
import notifier from '@/mixins/notifier'
import editorOptions from './editor-options'
import imageLoader from '@/mixins/image-loader'

export default {
  name: 'user-location-edit',
  data () {
    return {
      currentUser: firebase.auth().currentUser,
      location: null,
      editorOptions
    }
  },
  firebase: {
    media: mediaRef,
    galleries: galleriesRef
  },
  mixins: [imageLoader, notifier],
  methods: {
    updateLocation (state) {
      this.location.state = state
      let tempData = {
        ...this.location,
        createdBy: this.currentUser.uid,
        createdOn: (new Date()).toISOString()
      }
      locationsRef.child(this.$route.params.key).set(tempData).then(() => {
        if (state === 'saved') {
          this.showNotification('success', 'Location updated successfully')
        }
        if (state === 'published') {
          this.showNotification('success', 'Location updated and published successfully')
        }
      })
    },
    uploadImages (e) {
      let files = e.target.files
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        this.uploadImage(file)
      }
    },
    uploadImage (file) {
      let storageRef = firebase.storage().ref('images/locations/' + file.name)
      let uploadTask = storageRef.put(file)

      uploadTask.then(this.addImageToMedia)
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, this.handleUploadProgress, this.handleUploadError, this.handleUploadComplete)
    },
    handleUploadProgress (snapshot) {
      let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      this.showNotification('success', 'Uploading image ' + Math.floor(progress) + '% done.')

      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused')
          break
        case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running')
          break
      }
    },
    handleUploadError (error) {
      switch (error.code) {
        case 'storage/unauthorized':
          console.log('storage/unauthorized')
          // User doesn't have permission to access the object
          break
        case 'storage/canceled':
          console.log('storage/canceled')
          // User canceled the upload
          break
        case 'storage/unknown':
          console.log('storage/unknown')
          // Unknown error occurred, inspect error.serverResponse
          break
        default:
          console.log(error)
      }
    },
    handleUploadComplete () {
      console.log('Upload Complete!')
    },
    addImageToMedia (snapshot) {
      this.showNotification('success', snapshot.metadata.name + ' uploaded.')

      let mediaObj = {
        src: snapshot.downloadURL,
        path: snapshot.ref.fullPath,
        name: snapshot.metadata.name,
        contentType: snapshot.metadata.contentType,
        createdBy: this.currentUser.uid,
        createdOn: (new Date()).toISOString()
      }

      this.location.featuredImage = snapshot.downloadURL

      mediaRef.push(mediaObj)
    },
    loadCurrent () {
      locationsRef.child(this.$route.params.key).once('value', snapshot => {
        this.location = snapshot.val()
      })
    }
  },
  watch: {
    '$route' () {
      this.loadCurrent()
    }
  },
  mounted () {
    this.loadCurrent()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .gallery {
    margin: 16px;
  }

  .img-container {
    display: block;
    position: relative;
    width: 100%;
    padding-bottom: 100%;
  }

  .delete-button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1;
  }

  .info-tab {
    position: absolute;
    bottom: 0px;
    height: 28px;
    width: 100%;
    padding: 4px;
    background-color: black;
    color: white;
    opacity: 0.71;
    z-index: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .image-div {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    z-index: 0;
  }

  .service {
    background: #efefef;
    padding: 8px;
    border-radius: 4px;
    &__title {
      display: block;
      width: 100%;
      min-width: 240px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/LocationsEdit.vue